import { Trans } from '@lingui/react'
import { isNil } from 'ramda'

import { useClosePaidPayIn3CompletedMutation } from '@twisto/api-graphql'
import { ButtonGroup, TextButton } from '@twisto/components/atoms/button'
import { FormattedCurrencyNumber } from '@twisto/components/atoms/format'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { BigTickIcon } from '@twisto/icons'

import { useFlow } from '../../flow/flow.context'

import * as styles from './paid-pay-in-3-completed-step.styles'
import { numberOfDays } from '@twisto/locale'

export const PaidPayIn3CompletedStep = () => {
  const { sessionId, flow, actions } = useFlow<'PaidPayIn3CompletedStep'>()
  const { handleClose, triggerPaymentIntent } = actions

  const currentStep = flow.currentStep

  const [closePaidDividedPaymentsCompleted] =
    useClosePaidPayIn3CompletedMutation()

  const handlePayNow = () => {
    if (isNil(triggerPaymentIntent)) {
      throw new Error('triggerPaymentIntent was not provided')
    }
    triggerPaymentIntent({
      invoices: [currentStep.invoiceId],
    })
    handleClose?.()
  }

  const handlePayLater = () => {
    closePaidDividedPaymentsCompleted({
      variables: {
        auth: {
          sessionId,
        },
      },
    })
  }

  return (
    <div css={styles.root}>
      <Headline css={styles.headline}>
        <HeadlineIcon>
          <BigTickIcon color="primary" height="100%" width="100%" />
        </HeadlineIcon>
        <HeadlineTitle>
          <Trans id="flow.paidDividedPaymentsCompletedStep.title" />
        </HeadlineTitle>
        <HeadlineSubtitle>
          <Trans
            id="flow.paidDividedPaymentsCompletedStep.subtitle"
            values={{
              amount: (
                <FormattedCurrencyNumber
                  value={currentStep.acceptedOffer.amountPerPeriod}
                />
              ),
              repaymentInDays: numberOfDays(currentStep.repaymentInDays),
              months: currentStep.acceptedOffer.periodsCount,
            }}
          />
        </HeadlineSubtitle>
      </Headline>
      <ButtonGroup>
        <TextButton fullWidth onClick={handlePayNow}>
          <Trans
            id="flow.paidDividedPaymentsCompletedStep.button"
            values={{
              amount: (
                <FormattedCurrencyNumber
                  value={currentStep.acceptedOffer.amountPerPeriod}
                />
              ),
            }}
          />
        </TextButton>
        <TextButton fullWidth color="secondary" onClick={handlePayLater}>
          <Trans id="flow.paidDividedPaymentsCompletedStep.button.secondary" />
        </TextButton>
      </ButtonGroup>
    </div>
  )
}
